module.exports = __webpack_public_path__ + "img/captureHome.12cc4b72.png";